import { useContext } from 'react';
import type { CustomFilter, GetAgentResourcesResponse } from '@trinity/chat';
import { createNamedContext } from '@trinity/chat-components/utils';
import type { HeaderContextValue, ContextSearchContextValue } from './interfaces';

export const HeaderContextContext = createNamedContext<HeaderContextValue | undefined>(
  undefined,
  'Chat.Header.HeaderContextContext'
);

export function useHeaderContext(): HeaderContextValue {
  const ctx = useContext(HeaderContextContext);
  if (!ctx) {
    throw new Error('useHeaderContext must be used within HeaderContextContext.Provider');
  }
  return ctx;
}

export const ContextSearchContext = createNamedContext<ContextSearchContextValue | undefined>(
  undefined,
  'Chat.Header.ContextSearchContext'
);

export type AgentResourcesContextValue = {
  data: GetAgentResourcesResponse;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  territoryOptions: CustomFilter.ItemValue[];
  defaultTerritoryOption: CustomFilter.ItemValue | null;
  hasLoadedTerritories: boolean;
};

export const AgentResourcesContext = createNamedContext<AgentResourcesContextValue | undefined>(
  undefined,
  'Chat.Header.AgentResourcesContext'
);
